import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
} from "@mui/material";
import { TbFilterSearch } from "react-icons/tb";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { IoSearchOutline } from "react-icons/io5";
import { EachOrderDetails } from "./eachOrderDetails";
import { MdDeleteOutline } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { axiosInstance } from "../../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
  // { id: "username", label: "USERNAME", minWidth: 100, align: "center" },
  { id: "order_id", label: "ORDER ID", minWidth: 170, align: "center" },
  // { id: "orderitem_id", label: "ORDER ID", minWidth: 170, align: "center" },
  { id: "business_name", label: "RETAILER", minWidth: 170, align: "center" },
  { id: "payment_type", label: "PAYMENT TYPE", minWidth: 170, align: "center" },
  {
    id: "order_type",
    label: "ORDER TYPE",
    minWidth: 170,
    align: "center",
  },
  {
    id: "order_status",
    label: "Order Status",
    minWidth: 170,
    align: "center",
  },
  {
    id: "delivery_type",
    label: "DELIVERY TYPE",
    minWidth: 170,
    align: "center",
  },
  {
    id: "booking_date_time",
    label: "BOOKING DATE&TIME",
    minWidth: 170,
    align: "center",
  },
  // { id: "status", label: "STATUS", minWidth: 100, align: "center" },
  // { id: "approval", label: "APPROVAL", minWidth: 170, align: "center" },
  //   { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(
  orderitem_id,
  order_id,
  business_name,
  payment_type,
  order_type,
  order_status,
  delivery_type,
  booking_date_time
) {
  return {
    orderitem_id,
    order_id,
    business_name,
    payment_type,
    order_type,
    order_status,
    delivery_type,
    booking_date_time,
  };
}

const rows = [
  createData(
    "Order001",
    "ABC Medicine",
    "Credit Order",
    "Regular Order",
    "New Order",
    "Quick Delivery",
    "01/06/2025, 11:30 AM"
  ),
  createData(
    "Order002",
    "ABC Medicine",
    "Credit Order",
    "Snap Order",
    "In Process",
    "Far Delivery",
    "01/06/2025, 11:30 AM"
  ),
  createData(
    "Order003",
    "ABC Medicine",
    "Credit Order",
    "Adhoc Order",
    "Pending",
    "Quick Delivery",
    "01/06/2025, 11:30 AM"
  ),
];

function titleCase(str = "") {
  return str
    .replace(/_/g, " ")
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

const ORDER_TYPE_STATUS_OPTIONS = [
  { label: "New Order", value: "new_order" },
  { label: "Cancelled by Wholesaler", value: "cancelled_by_wholesaler" },
  { label: "Pending", value: "pending" },
  { label: "In Process", value: "in_process" },
  { label: "Payment Due", value: "payment_due" },
  { label: "Accepted by Retailer", value: "accepted_by_retailer" },
  { label: "Cancelled by Retailer", value: "cancelled_by_retailer" },
  { label: "Payment Success", value: "payment_success" },
  { label: "Ready for Delivery", value: "ready_for_delivery" },
  { label: "Accepted by Ryder", value: "accepted_by_ryder" },
  { label: "Out for Delivery", value: "out_for_delivery" },
  { label: "Delivered", value: "delivered" },
  { label: "Failed", value: "failed" },
];

const PAYMENT_TYPE_OPTIONS = [
  { label: "Credit Order", value: "credit_order" },
  { label: "Payment Order", value: "payment_order" },
];

const DELIVERY_TYPE_OPTIONS = [
  { label: "Quick Delivery", value: "quick_delivery" },
  { label: "Far Delivery", value: "far_delivery" },
];

const ORDER_CATEGORY_OPTIONS = [
  { label: "Regular", value: "regular" },
  { label: "Snap", value: "snap" },
  { label: "Adhoc", value: "adhoc" },
];

export function EditOrderHistory() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [wholesalerOrdersHistory, setWholesalerOrdersHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const WholesalerId = localStorage.getItem("wholesaler_ID") || "";
  console.log("Wholesaler Orders History List:", WholesalerId);

  // const fetchWholesalerOrdersHistory = async () => {
  //   if (!WholesalerId) {
  //     setWholesalerOrdersHistory([]);
  //     return;
  //   }

  //   setLoading(true);
  //   setError("");
  //   try {
  //     const res = await axiosInstance.get(
  //       `/admin/order-history/?wholesaler_id=${WholesalerId}`
  //     );
  //     console.log("✅ Wholesaler Orders History List response:", res.data);
  //     if (res.data.status === "success" && Array.isArray(res.data.data)) {
  //       const formatted = res.data.data.map((item) => ({
  //         order_id: item?.order?.order_id || "--",
  //         id: item.orderitem_id,
  //         orderitem_id: `${String(item.orderitem_id).padStart(3, "0")}`,
  //         business_name: item.retailer?.business_name || "--",
  //         payment_type: titleCase(item.order.payment_type),
  //         order_type: titleCase(item.order.order_type) + " Order",
  //         order_status: titleCase(item.order_status),
  //         delivery_type: titleCase(item.order.delivery_type),
  //         booking_date_time: new Date(
  //           item.order.booking_date_time
  //         ).toLocaleString(),
  //       }));
  //       setWholesalerOrdersHistory(formatted);
  //     } else {
  //       setError("Failed to fetch Wholesaler Orders History data.");
  //     }
  //   } catch (err) {
  //     console.error("❌ Error fetching Wholesaler  Orders History data:", err);
  //     setError("Something went wrong. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchWholesalerOrdersHistory = async () => {
    if (!WholesalerId) {
      setWholesalerOrdersHistory([]);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        `/admin/order-history/?wholesaler_id=${WholesalerId}`
      );
      console.log("Wholesaler Orders History List response:", res.data);

      if (res.data.status === "success" && Array.isArray(res.data.data)) {
        const formatted = res.data.data.map((item) => {
          const businessType = item.retailer?.business_type;
          let businessName = "--";

          //  Business Type Logic
          if (businessType === "medical_store") {
            businessName = item.retailer?.business_name || "--";
          }
          if (businessType === "doctor") {
            businessName =
              item.retailer?.clinic_name ||
              item.retailer?.business_name ||
              "--";
          }
          if (businessType === "hospital") {
            businessName = item.retailer?.hospital_name || "--";
          }
          if (businessType === "lab_diagonastic") {
            businessName = item.retailer?.diagnostic_name || "--";
          }

          return {
            order_id: item?.order?.order_id || "--",
            id: item.orderitem_id,
            orderitem_id: `${String(item.orderitem_id).padStart(3, "0")}`,
            business_name: businessName,
            payment_type: titleCase(item.order.payment_type),
            order_type: titleCase(item.order.order_type) + " Order",
            order_status: titleCase(item.order_status),
            delivery_type: titleCase(item.order.delivery_type),
            booking_date_time: new Date(
              item.order.booking_date_time
            ).toLocaleString(),
          };
        });

        setWholesalerOrdersHistory(formatted);
      } else {
        setError("Failed to fetch Wholesaler Orders History data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Wholesaler Orders History data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWholesalerOrdersHistory();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //filter modal state
  const [showFilter, setShowFilter] = useState(false);
  const [selectedOrderTypeStatusOptions, setSelectedOrderTypeStatusOptions] =
    useState("");
  const [selectedPaymentTypeOptions, setSelectedPaymentTypeOptions] =
    useState("");
  const [selectedDeliveryTypeOptions, setSelectedDeliveryTypeOptions] =
    useState("");
  const [selectedOrderCategoryOptions, setSelectedOrderCategoryOptions] =
    useState("");

  // Fetch with current filters
  const applyFilters = async () => {
    setShowFilter(false);
    setLoading(true);
    setError("");
    try {
      const body = {
        wholesaler_id: WholesalerId,
        order_status: selectedOrderTypeStatusOptions,
        payment_type: selectedPaymentTypeOptions,
        order_type: selectedOrderCategoryOptions,
        delivery_type: selectedDeliveryTypeOptions,
      };
      const res = await axiosInstance.post(
        `/admin/order-history/?wholesaler_id=${WholesalerId}`,
        body
      );
      if (res.data.status === "success" && Array.isArray(res.data.data)) {
        const formatted = res.data.data.map((item) => ({
          order_id: item?.order?.order_id || "--",
          id: item.orderitem_id,
          orderitem_id: `Order${String(item.orderitem_id).padStart(3, "0")}`,
          business_name: item.retailer?.business_name || "--",
          payment_type: titleCase(item.order.payment_type),
          order_type: titleCase(item.order.order_type) + " Order",
          order_status: titleCase(item.order_status),
          delivery_type: titleCase(item.order.delivery_type),
          booking_date_time: new Date(
            item.order.booking_date_time
          ).toLocaleString(),
        }));
        setWholesalerOrdersHistory(formatted);
      } else {
        setError("Filter failed.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
      setPage(0);
    }
  };

  const clearAllFilters = () => {
    setSelectedOrderTypeStatusOptions("");
    setSelectedPaymentTypeOptions("");
    setSelectedDeliveryTypeOptions("");
    setSelectedOrderCategoryOptions("");
    fetchWholesalerOrdersHistory();
  };

  const removeStateFilter = () => {
    setSelectedOrderTypeStatusOptions("");
    setSelectedPaymentTypeOptions("");
    setSelectedDeliveryTypeOptions("");
    setSelectedOrderCategoryOptions("");
    applyFilters();
  };

  const removeCityFilter = () => {
    setSelectedOrderTypeStatusOptions("");
    setSelectedPaymentTypeOptions("");
    setSelectedDeliveryTypeOptions("");
    setSelectedOrderCategoryOptions("");
    applyFilters();
  };

  useEffect(() => {
    fetchWholesalerOrdersHistory();
  }, []);

  // react-select libray styles
  const options = [
    { value: "Approved", label: "Approved", color: "#34C759" },
    { value: "Rejected", label: "Rejected", color: "#FF3B30" },
    { value: "Pending", label: "Pending", color: "#4184D1" },
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#4184D1", // Change placeholder text color
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#4184D1", // Change dropdown arrow color
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#E7F0F9" : "white", // Change background on hover
      color: state.data.color, //apply unique for each option
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color, // Apply the selected option's color
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the right-side border
    }),
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <div className="admin-top-container-details">
          <div className="admin-listText">List Of Orders</div>
          {/* <div>
            <select className="listAdmin-showRecords">
              <option>Show No of Records</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input type="text" placeholder="Search"></input>
            </div>
          </div> */}
          <div className="btnFilter">
            <button onClick={() => setShowFilter(true)}>
              <TbFilterSearch /> Filter
            </button>
          </div>
        </div>
        {/* filter modal  */}
        <Modal
          show={showFilter}
          onHide={() => setShowFilter(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="filterGridTwoByTwo">
              {/* Order Status */}
              <div className="filterBoxTwoByTwo">
                <div className="filterTitleTwoByTwo">
                  Filter by Order Status
                </div>
                {ORDER_TYPE_STATUS_OPTIONS.map(({ label, value }) => (
                  <div className="stateListTwoByTwo" key={value}>
                    <input
                      type="checkbox"
                      checked={selectedOrderTypeStatusOptions === value}
                      onChange={() => {
                        setSelectedOrderTypeStatusOptions((prev) =>
                          prev === value ? "" : value
                        );
                      }}
                      disabled={
                        selectedOrderTypeStatusOptions &&
                        selectedOrderTypeStatusOptions !== value
                      }
                    />
                    <span>{label}</span>
                  </div>
                ))}
              </div>

              {/* Payment Type */}
              <div className="filterBoxTwoByTwo">
                <div className="filterTitleTwoByTwo">
                  Filter by Payment Type
                </div>
                {PAYMENT_TYPE_OPTIONS.map(({ label, value }) => (
                  <div className="stateListTwoByTwo" key={value}>
                    <input
                      type="checkbox"
                      checked={selectedPaymentTypeOptions === value}
                      onChange={() => {
                        setSelectedPaymentTypeOptions((prev) =>
                          prev === value ? "" : value
                        );
                      }}
                      disabled={
                        selectedPaymentTypeOptions &&
                        selectedPaymentTypeOptions !== value
                      }
                    />
                    <span>{label}</span>
                  </div>
                ))}
              </div>

              {/* Delivery Type */}
              <div className="filterBoxTwoByTwo">
                <div className="filterTitleTwoByTwo">
                  Filter by Delivery Type
                </div>
                {DELIVERY_TYPE_OPTIONS.map(({ label, value }) => (
                  <div className="stateListTwoByTwo" key={value}>
                    <input
                      type="checkbox"
                      checked={selectedDeliveryTypeOptions === value}
                      onChange={() => {
                        setSelectedDeliveryTypeOptions((prev) =>
                          prev === value ? "" : value
                        );
                      }}
                      disabled={
                        selectedDeliveryTypeOptions &&
                        selectedDeliveryTypeOptions !== value
                      }
                    />
                    <span>{label}</span>
                  </div>
                ))}
              </div>

              {/* Order Category */}
              <div className="filterBoxTwoByTwo">
                <div className="filterTitleTwoByTwo">
                  Filter by Order Category
                </div>
                {ORDER_CATEGORY_OPTIONS.map(({ label, value }) => (
                  <div className="stateListTwoByTwo" key={value}>
                    <input
                      type="checkbox"
                      checked={selectedOrderCategoryOptions === value}
                      onChange={() => {
                        setSelectedOrderCategoryOptions((prev) =>
                          prev === value ? "" : value
                        );
                      }}
                      disabled={
                        selectedOrderCategoryOptions &&
                        selectedOrderCategoryOptions !== value
                      }
                    />
                    <span>{label}</span>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="btnCancelFilter"
              onClick={() => setShowFilter(false)}
            >
              Cancel
            </Button>
            <Button className="btnApplyFilter" onClick={applyFilters}>
              Apply Filter
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Selected Filters */}
        {(selectedOrderTypeStatusOptions ||
          selectedPaymentTypeOptions ||
          selectedDeliveryTypeOptions ||
          selectedOrderCategoryOptions) && (
          <div>
            <div className="filteredDataText">
              <div>Filtered Results</div>
              <div onClick={clearAllFilters} style={{ cursor: "pointer" }}>
                <MdDeleteOutline />
                <span className="ps-1">Clear All</span>
              </div>
            </div>
            <div className="seletedFilter">
              {selectedOrderTypeStatusOptions && (
                <div>
                  <span className="ps-1">{selectedOrderTypeStatusOptions}</span>
                  <IoIosCloseCircleOutline
                    style={{ cursor: "pointer" }}
                    onClick={removeStateFilter}
                  />
                </div>
              )}

              {selectedPaymentTypeOptions && (
                <div>
                  <span className="ps-1">{selectedPaymentTypeOptions}</span>
                  <IoIosCloseCircleOutline
                    style={{ cursor: "pointer" }}
                    onClick={removeStateFilter}
                  />
                </div>
              )}

              {selectedDeliveryTypeOptions && (
                <div>
                  <span className="ps-1">{selectedDeliveryTypeOptions}</span>
                  <IoIosCloseCircleOutline
                    style={{ cursor: "pointer" }}
                    onClick={removeStateFilter}
                  />
                </div>
              )}

              {selectedOrderCategoryOptions && (
                <div>
                  <span className="ps-1">{selectedOrderCategoryOptions}</span>
                  <IoIosCloseCircleOutline
                    style={{ cursor: "pointer" }}
                    onClick={removeCityFilter}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : wholesalerOrdersHistory.length > 0 ? (
                  wholesalerOrdersHistory
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={`${column.id}-column tableCelldata`}
                              onClick={
                                column.id === "order_id"
                                  ? () =>
                                      navigate(
                                        `/manage-wholesaler-eachorder/${row.id}`
                                      )
                                  : undefined
                              }
                              sx={{
                                cursor:
                                  column.id === "order_id"
                                    ? "pointer"
                                    : "default",
                                color:
                                  column.id === "order_id" ? "#4184D1" : "",
                              }}
                            >
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={wholesalerOrdersHistory.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </>
  );
}
